import { alertController,loadingController } from "@ionic/core";
export default{
    async presentResponseAlert(type: string,message: string) {
        const alert = await alertController
          .create({
            header: type+'!',
            // subHeader: 'Subtitle',
            message: message,
            buttons: ['OK'],
          });
        await alert.present();
  
      },
      async presentLoading(text: string) {
        const loading = await loadingController
          .create({
            message: text+'.....',
            duration: 60 * 1000,
          });
  
        await loading.present();
        return loading;
      }
}